import { Fragment, ReactElement, ReactNode, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Button from './Button';

type OverlayDialogProps = {
  open: boolean;
  setOpen: (val: boolean) => void;
  children?: ReactNode;
};

/**
 * A OverlayDialog for showing confirmation/error.
 * @param props - Properties of the OverlayDialogProps.
 * @returns - React Element.
 */
export default function OverlayDialog(props: OverlayDialogProps): ReactElement {
  const { open, setOpen, children } = props;

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-400 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-[10000] overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-background-900 text-center shadow-xl transition-all p-2">
                {children || (
                  <>
                    <div className=" px-4 pb-4 pt-5">
                      <div className="sm:flex sm:items-center">
                        <div className="mt-3 text-center sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-white text-sm font-medium">
                            Comfort Factor
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-gray-300 text-xs font-normal ">
                              Gateway #ID has been added to the list
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-background-900 px-4 py-3 sm:px-6 pb-4">
                      <Button
                        theme="primary"
                        size="sm"
                        name="Close"
                        onClick={() => setOpen(false)}
                      />
                    </div>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
